module.exports = __webpack_public_path__ + "img/dashboard.17ab72f4.svg";